import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { ResponsiveElementModule } from '@fleet/layout';
import { TitleCaseAndCleanPipeModule } from '@fleet/pipes';
import { StatusChipModule } from '@fleet/ui';
import { TicketSearchResultsComponent } from './ticket-search-results.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InternationalizationDatePipeModule } from '@fleet/internationalization';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { HasFunctionPipeModule } from '@fleet/security-shared';

const lazyTranslationloader = ['en_au', 'es', 'en_us'].reduce(
  (acc: { [key: string]: () => Promise<any> }, lang) => {
    acc[lang] = () => import(`./i18n/${lang}.json`);

    return acc;
  },
  {}
);
@NgModule({
  declarations: [TicketSearchResultsComponent],
  imports: [
    CommonModule,
    MatTableModule,
    TitleCaseAndCleanPipeModule,
    MatButtonModule,
    MatIconModule,
    ResponsiveElementModule,
    MatIconModule,
    MatMenuModule,
    StatusChipModule,
    MatMenuModule,
    MatTooltipModule,
    HasFunctionPipeModule,
    InternationalizationDatePipeModule,
    TranslocoDirective,
  ],
  exports: [TicketSearchResultsComponent],
  providers: [
    provideTranslocoScope({
      scope: 'ticketSearchResults',
      loader: lazyTranslationloader,
    }),
  ],
})
export class TicketSearchResultsModule {}
